export const SERVER = "https://www.terradata.com.br/";

export const LOGIN = SERVER + 'api/auth/login.php';